import { KYMW1201Component } from "./kymw1201.component";
import { FeatureCode } from "./vo/feature-code.model";
import { CatalogInfo } from "./vo/catalog-info.model";
import { PublishPlanGoodsCategoryListInfo, PublishPlanGoodsCategory } from "./vo/publish-plan-goods-category-list-info.model";
import { SaveCycleInfo } from "./vo/save-cycle-info.model";
import { RegistCycleInfo } from "./vo/regist-cycle-info.model";
import { OrderNumQuota } from "./vo/order-num-quota.model";
import { GetCodeListResponse } from 'src/app/commons/kymw02/api-services/get-code-list.service';
import { PublishPlanGoodsEditableCategory } from "./vo/publish-plan-goods-category-list-editable-info.model";

/**
 * 企画回別商品一覧画面の値を管理するクラス
 *
 * @export KYMW1201Model
 * @class KYMW1201Model
 */
export class KYMW1201Model {

public kymw1201Component: KYMW1201Component;

  // 遷移元 バイヤーコード
  public buyerCode = "";
  // ユーザの取引先コード
  public supplierCode = "";

  // 受注コード
  public orderCode = '';
  // 媒体区分
  public mediumType = '';
  // 初期表示フラグ
  public initFlg = '1';
  // 特集コードリスト
  public featureCodeList: FeatureCode[] = [];
  // 企画回情報
  public catalogInfo: CatalogInfo = new CatalogInfo();
  // 企画回別商品一覧情報
  public publishPlanGoodsCategoryListInfo: PublishPlanGoodsCategoryListInfo = new PublishPlanGoodsCategoryListInfo();
  // 企画回別商品情報
  public publishPlanGoodsCategoryInfo: PublishPlanGoodsCategory[] = [];
  public publishPlanGoodsCategoryInfoOrigin: PublishPlanGoodsEditableCategory[] = [];
  // サイクル情報保存リスト
  public saveCycleInfo: SaveCycleInfo = null;
  // サイクル情報登録
  public registCycleInfo: RegistCycleInfo = null;
  // ページング戻る非活性
  public prevDisabled = false;
  // ページング次へ非活性
  public nextDisabled = false;
  // ノンブル非活性リスト
  public folioDisabled: Array<boolean> = [];

  // 注文コード割当コード
  public orderNumQuotaList: OrderNumQuota[] = [];

  // コード区分を指定して取得したコードリスト
  // EDLPリスト
  public edlpList: GetCodeListResponse = [];
  // 価格パターンリスト
  public pricePatternList: GetCodeListResponse = [];
  // 価格プロモーションリスト
  public pricePromotionList: GetCodeListResponse = [];
  // 登場区分リスト
  public appearDivList: GetCodeListResponse = [];
  // コマプロモーションリスト
  public komaPromotionList: GetCodeListResponse = [];
  // プロモーションマークリスト
  public promotionMarkList: GetCodeListResponse = [];

  // 画面で表示・操作するためのコードリスト
  // EDLPラベルリスト
  public edlpLabelList: LabelInfo[] = [];
  // 価格パターンラベルリスト
  public pricePatternLabelList: LabelInfo[] = [];
  // 価格プロモーションラベルリスト
  public pricePromotionLabelList: LabelInfo[] = [];
  // 登場区分ラベルリスト
  public appearDivLabelList: LabelInfo[] = [];
  // コマプロモーションラベルリスト
  public komaPromotionLabelList: LabelInfo[] = [];
  // プロモーションマークラベルリスト
  public promotionMarkLabelList: LabelInfo[] = [];

  // 計画数（フィルタ） - 計画数（修正後）
  public filteredPlannedValuePlannedValue: number = null;
  // 計画数（フィルタ） - 供給高
  public filteredPlannedValueSupplyAmount: number = null;
  // 計画数（フィルタ） - GP高
  public filteredPlannedValueGP: number = null;
  // 計画数（フィルタ） - GPR
  public filteredPlannedValueGPR: number = null;
  // 計画数（フィルタ） - アイテム数
  public filteredPlannedValueItemNum: number = null;
  // 計画数（全体） - 計画数（修正後）
  public plannedValuePlannedValue: number = null;
  // 計画数（全体） - 供給高
  public plannedValueSupplyAmount: number = null;
  // 計画数（全体） - GP高
  public plannedValueGP: number = null;
  // 計画数（全体） - GPR
  public plannedValueGPR: number = null;
  // 計画数（全体） - アイテム数
  public plannedValueItemNum: number = null;
  // 予算比 - 計画数（修正後）
  public budgetRatioPlannedValue: number = null;
  // 予算比 - 供給高
  public budgetRatioSupplyAmount: number = null;
  // 予算比 - GP高
  public budgetRatioGP: number = null;
  // 予算比 - GPR
  public budgetRatioGPR: number = null;

  /** 変更内容破棄 */
  revertPublishPlanGoodsCategoryInfoChanges() {
    this.publishPlanGoodsCategoryInfo.forEach(_i => {
      const origin = this.findOrigin(_i);
      if (!origin) return;
      this.revertPublishPlanGoodsCategoryInfo(_i, origin);
    });
  }
   
  /** 元の情報取得 */
  findOrigin(item) {
    return this.publishPlanGoodsCategoryInfoOrigin.find(
      _o => _o.pcode === item.pcode
    );
  }
   
  /** 変更内容を元に戻す */
  revertPublishPlanGoodsCategoryInfo(item, origin) {
    Object.keys(origin).forEach(_k => {
      item[_k] = origin[_k];
    });
  }
}

// レスポンス構造
export class LabelInfo {
  constructor(
    public value: string,
    public label: string,
  ){}
};

